import { render, staticRenderFns } from "./DateTag.vue?vue&type=template&id=6b8edab6"
import script from "./DateTag.vue?vue&type=script&lang=js"
export * from "./DateTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports